<button color="primary" (click)="consultarAyuda()" mat-icon-button [matTooltip]="'ayuda' | translate" matTooltipClass="colortooltip">
  <mat-icon fontSet="material-symbols-outlined">{{ icon }}</mat-icon>
</button>
